import { render, staticRenderFns } from "./Plans.vue?vue&type=template&id=68400cfc&scoped=true&"
import script from "./Plans.vue?vue&type=script&lang=ts&"
export * from "./Plans.vue?vue&type=script&lang=ts&"
import style0 from "./Plans.vue?vue&type=style&index=0&id=68400cfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68400cfc",
  null
  
)

export default component.exports